import axios from '@/api'

/**
 * 发送预约消息
 */
export const sendAppointmentMessage = (data) => {
  return axios.post('/message/send/v1/appointment', data).then(res => res)
}

/**
 * 消息分类最新记录列表
 */
export const getBusinessList = () => {
  return axios.get('/message/business/v1/list').then(res => res.data)
}

/**
 * 消息列表
 */
export const getMessageList = (params) => {
  return axios.get('/message/v1/list', { params }).then(res => res.data)
}

/**
 * 更新单个为已读
 */
export const markSingleRead = (data) => {
  return axios.put('/message/v1/single', data).then(res => res.data)
}

/**
 * 标记分类为已读
 */
export const markBusinessTypeRead = (businessTypeId) => {
  return axios.put('/message/read/v1/business?businessTypeId='+businessTypeId).then(res => res.data)
}

/**
 * 标记所有为已读
 */
export const markAllRead = (data) => {
  return axios.put('/message/read/v1/all', data).then(res => res.data)
}

/**
 * 统计未读
 */
export const countUnRead = () => {
  return axios.get('/message/count/v1/unread').then(res => res.data)
}

/**
 * 统计业务类型未读
 */
export const countBusinessUnRead = () => {
  return axios.get('/message/count/business/v1/unread').then(res => res.data)
}